export const Filter = {
  ByChatStatus: 'ByChatStatus',
  ByDate: 'ByDate',
  BySessionStatus: 'BySessionStatus',
  ByReviewStatus: 'ByReviewStatus',
}
